// Resolve a public asset (anything under public/, e.g. 'assets/logos/x.svg') to a
// URL that works on EVERY route.
//
// The app references public assets with bare relative paths ('assets/x.png'). A
// relative URL resolves against the current document path, so it only happened to
// work on the single-segment homepage ('/songhunt/' → '/songhunt/assets/x.png').
// On trailing-slash or multi-segment routes it broke:
//   /songhunt/signup/                 → /songhunt/signup/assets/x.png   (404)
//   /songhunt/playlist/taylor-swift   → /songhunt/playlist/assets/x.png (404)
//   /songhunt/similar/<deep-link>     → /songhunt/similar/assets/x.png  (404)
// Angular avoided this with <base href="/songhunt/">; Vite's index.html has none
// (a <base> tag would break same-document SVG url(#…) filter refs, which the app
// uses), so we prefix BASE_URL explicitly instead.
//
// Absolute URLs (http(s):, protocol-relative, root-absolute), data:/blob: URIs and
// already-based paths are returned unchanged — important because AppImage also
// receives remote artwork URLs.
export function assetUrl(path: string): string {
  if (!path) return path;
  if (/^(?:[a-z]+:|\/\/|\/)/i.test(path)) return path;
  // import.meta.env.BASE_URL always ends with '/'. Drop any leading './' or '/'.
  return import.meta.env.BASE_URL + path.replace(/^\.?\//, '');
}
